module.exports = __webpack_public_path__ + "static/media/chooseCip_pic2.ce2e7c47.png";